import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import SearchDropdown from 'shared/SearchDropdown/SearchDropdown'
import Validate from 'shared/Forms/Validate'
import api from './api'

const AirportDropdown = (props) => {
  const airports = useSelector((state) => state.airports.items)
  const { error } = props
  const items = props.items ? airports.filter((d) => props.items.includes(d.iata)) : airports

  return (
    <Validate validation_errors={error}>
      <SearchDropdown
        intent={error ? 'danger' : undefined}
        activeItem={props.activeItem}
        text={(d) => d.iata}
        items={items}
        width={props.fill ? null : props.width ? props.width : 80}
        placeholder={props.placeholder ? props.placeholder : 'Airport'}
        onChange={async (d) => {
          if (d.key) {
            const json = await api.getAirportData(d.iata)
            props.onChange(json[0])
          } else {
            props.onChange({ name: null })
          }
        }}
        style={props.style}
      />
    </Validate>
  )
}

export default AirportDropdown
